import createLinkAdapter from './link-adapter.component'

export default createLinkAdapter
